import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { Modal, Button, Row, Col, Container } from 'react-bootstrap';
import './CkeditorModal.css';
import { axiosPostServicecopilot } from '../api/axiosBaseUrl';
import Spinner from '../../../helpers/Spinner';
import { track } from './WithTelemetry';
import $ from 'jquery';
import axios from 'axios';

const LabelComponent = ({ 
    show,
    handleClose,
    modelName,
    title,
    selectedData,
    resultData,
    handleRegenerate,
    handleKeep,
    showLoader,
    isKeepDisabled
}) => (
    <Modal className='copilot-modal' show={show} onHide={handleClose} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
            <Modal.Title>{modelName}</Modal.Title>
        </Modal.Header>
        <Modal.Body className='copilot-modal-body'>
            {showLoader && <Spinner />}
            {!showLoader && (
                <Container className='p-0'>
                    <div className='copilot-modal-prompt'>
                        <label className="copilot-modal-label">AI Generated Text:</label>
                        <div className='copilot-modal-aiDivArea' dangerouslySetInnerHTML={{ __html: resultData }}></div>
                    </div>
                    <div className='copilot-ai-prompt-label'>
                        <label className="copilot-modal-prompt-label">This is AI generated content, please check for accuracy.</label>
                    </div>
                </Container>
            )}
        </Modal.Body>
        <Modal.Footer>
            <Button className='copilot-modal-btn-generate' onClick={handleKeep} disabled={isKeepDisabled}>
                Keep
            </Button>
            <Button className='copilot-modal-btn-generate' onClick={handleRegenerate}>
                Regenerate
            </Button>
            <Button className='copilot-modal-btn-discard' onClick={handleClose}>
                Discard
            </Button>
        </Modal.Footer>
    </Modal>
);

const WriteAPromptComponent = ({ 
    show, 
    handleClose,
    showLoader,
    handleAIPromptTextChange,
    aiContextValue,
    handleGenerate,
    resultData,
    selectedData,
    showWriteAPromptButtons,
    handleWritePromptRegenerate,
    handleWritePromptKeep,
    isKeepDisabled
}) => (
    <Modal className='copilot-write-prompt-modal' show={show} onHide={handleClose} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
            <Modal.Title>Draft with Copilot</Modal.Title>
        </Modal.Header>
        <Modal.Body className='copilot-modal-body'>
            <Container className='p-0'>
                <div className='copilot-modal-writeAPrompt'>
                    {selectedData && (
                        <div className='copilot-modal-selected-prompt mb-3'>
                            <label className="copilot-modal-label">Selected Text:</label>
                            <div className='copilot-modal-aiDivArea' dangerouslySetInnerHTML={{ __html: selectedData }}></div>
                        </div>
                    )}
                    <div className='copilot-modal-write-prompt mb-1 mt-2'>
                        <label className="copilot-modal-label">Write a prompt:</label>
                        <textarea 
                            className="copilot-modal-aiTextarea"
                            value={aiContextValue}
                            onChange={handleAIPromptTextChange}
                            name="aiContext"
                            rows="3"
                            cols="96"
                            placeholder="Write a prompt with this content..." 
                            style={{ marginRight: '5px' }}
                        />
                    </div>
                    <div className='copilot-modal-result-prompt'>
                        <label className="copilot-modal-label">AI Generated Text:</label>
                        {showLoader ? <div style={{position:'relative'}} className='copilot-modal-aiDivArea'><Spinner className="fixed-spinner" /></div> : <div className='copilot-modal-aiDivArea' dangerouslySetInnerHTML={{ __html: resultData }}></div>}
                    </div>
                </div>
                <div className='copilot-ai-prompt-label'>
                    <label className="copilot-modal-prompt-label">This is AI generated content, please check for accuracy.</label>
                </div>
            </Container>
        </Modal.Body>
        <Modal.Footer>
            {showWriteAPromptButtons ? (
                <>
                    <Button className='copilot-modal-btn-generate' onClick={handleWritePromptKeep} disabled={isKeepDisabled}>
                        Keep
                    </Button>
                    <Button className='copilot-modal-btn-generate' onClick={handleWritePromptRegenerate}>
                        Regenerate
                    </Button>
                    <Button className='copilot-modal-btn-discard' onClick={handleClose}>
                        Discard
                    </Button>
                </>
            ) : (
                <Button className='copilot-modal-btn-generate' onClick={handleGenerate}>
                    Generate
                </Button>
            )}
        </Modal.Footer>
    </Modal>
);

const ModalContainer = () => {
    const [showWriteAPromptModal, setShowWriteAPromptModal] = useState(false);
    const [showLabelModal, setShowLabelModal] = useState(false);
    const [selectedData, setSelectedData] = useState();
    const [resultData, setResultData] = useState('');
    const [title, setTitle] = useState('');
    const [label, setLabel] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [aICommand, setAICommand] = useState('');
    const [aiContextValue, setAiContextValue] = useState('');
    const [showWriteAPromptButtons, setShowWriteAPromptButtons] = useState(false);
    const [modalInstanceId, setModalInstanceId] = useState('');
    const [isKeepDisabled, setIsKeepDisabled] = useState(true);
    const [apiController, setApiController] = useState(null);
    const [cancelTokenSource, setCancelTokenSource] = useState(null);

    const handleAIPromptTextChange = (e) => {
        setAiContextValue(e.target.value);
    };

    const fetchData = async (content, cancelToken) => {
        try {
            setShowLoader(true);
            const payload = {
                assistancetext: `${content}`,
            };
            const response = await axiosPostServicecopilot(
                `api/sdmactivity/getopenaiassistanceasync`,
                payload,
                cancelToken // Pass the cancellation token here
            );
            if (response.data) {
                return response.data;
            } else {
                throw new Error('No data received');
            }
        } catch (error) {
            if (axios.isCancel(error)) {
                console.log('API call canceled');
            } else {
                console.error('Error fetching data:', error);
            }
            return null;
        } finally {
            setShowLoader(false);
            setIsKeepDisabled(false);
        }
    };

    const handleShowWriteAPrompt = async (event) => {
        console.log('handleShowWriteAPrompt called with event:', event);
    
        const { label, title, aICommand, labeledKey, selectedData, instanceId } = event.detail;
        console.log('Event details:', { label, title, aICommand, labeledKey, selectedData, instanceId });
    
        trackEvent(labeledKey, title);
        setModalData(label, title, aICommand, selectedData);
        setModalInstanceId(instanceId);
        setShowWriteAPromptModal(true);
        setResultData('');
        setAiContextValue('');
        setIsKeepDisabled(true);
    
        // Create a new cancellation token source
        const source = axios.CancelToken.source();
        setCancelTokenSource(source);
    };

    const handleCloseWriteAPrompt = () => {
        if (cancelTokenSource) {
            cancelTokenSource.cancel('Operation canceled by the user.'); // Cancel the API call
        }
        setShowWriteAPromptButtons(false); // Reset to show "Generate" button
        setShowWriteAPromptModal(false); // Close the modal
        setAiContextValue(''); // Clear the AI context value
        setResultData(''); // Clear the result data
        setShowLoader(false); // Stop the loader
        setIsKeepDisabled(true); // Disable the "Keep" button
    };

    // const fetchData = async (content) => {
    //     try {
    //         setShowLoader(true);
    //         const payload = {
    //             assistancetext: `${content}`,
    //         };
    //         const response = await axiosPostService(`api/sdmactivity/getopenaiassistanceasync`, payload);
    //         if (response.data) {
    //             return response.data;
    //         } else {
    //             throw new Error('No data received');
    //         }
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //         return null;
    //     } finally {
    //         setShowLoader(false);
    //         setIsKeepDisabled(false);
    //     }
    // };

    const convertTextToHTML = async (text) => {
        if (/<[^>]+>/g.test(text)) {
            return text; // Return if already valid HTML
        }
    
        // Convert headings
        text = text.replace(/^(#{1,6})\s*(.*?)$/gm, (match, hashes, heading) => {
            const level = hashes.length;
            return `<h${level}>${heading}</h${level}>`;
        });
    
        // Convert bold and italic
        text = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        text = text.replace(/__(.*?)__/g, '<strong>$1</strong>');
        text = text.replace(/\*(.*?)\*/g, '<em>$1</em>');
        text = text.replace(/_(.*?)_/g, '<em>$1</em>');
    
        // Convert lists
        text = text.replace(/(?:^|\n)[\*\-]\s+(.*?)(?=\n|$)/g, '<li>$1</li>'); // Convert list items
        text = text.replace(/(<li>.*?<\/li>)(?!(\n|$)<li>)/g, '<ul>$1</ul>'); // Wrap consecutive <li> elements in a single <ul>
        text = text.replace(/<\/ul>\s*<ul>/g, ''); // Merge adjacent <ul> tags
        text = text.replace(/(<ul>.*<\/ul>)(?!(\n|$)<ul>)/g, '<ul>$1</ul>'); // Ensure nested <ul> wraps <ul> without nesting

        // Remove unnecessary <br> and &nbsp; tags
        text = text.replace(/<br\s*\/?>/g, ''); // Remove all <br> tags
        text = text.replace(/&nbsp;/g, ' ');
    
        // Ensure block-level elements are not wrapped in <p> tags
        const blockElements = ['<ul>', '</ul>', '<li>', '</li>', '<h1>', '</h1>', '<h2>', '</h2>', '<h3>', '</h3>', '<h4>', '</h4>', '<h5>', '</h5>', '<h6>', '</h6>'];
        text = text.split('\n\n').map((paragraph) => {
            if (blockElements.some((el) => paragraph.includes(el))) {
                return paragraph; // Return block-level elements as-is
            }
            return `<p>${paragraph.trim()}</p>`; // Wrap other content in <p>
        }).join('');
    
        // Ensure plain text following block-level elements is wrapped in <p> tags
        text = text.replace(/(<\/(?:ul|h[1-6])>)(\s*[^<]+)/g, '$1<p>$2</p>');

        // Remove <br> tags that might have been added after <p> tags
        text = text.replace(/<\/p>\s*<br\s*\/?>/g, '</p>');
        return text;
    };

    const handleShowLabel = async (event) => {
        const { label, title, aICommand, labeledKey, selectedData, instanceId } = event.detail;
        trackEvent(labeledKey, title);
        setModalData(label, title, aICommand, selectedData);
        setModalInstanceId(instanceId);
        setShowLabelModal(true);
        setIsKeepDisabled(true);
        const resp = await fetchData(`${aICommand} ${selectedData}`);
        let htmlString = resp.replace("```html\n", "");
        htmlString = htmlString.replace("```", "");
        htmlString = await convertTextToHTML(htmlString);
        if (aICommand === 'summarize') {
            htmlString = htmlString.replace(/\n/g, "</br>");
        }
        setResultData(htmlString);
    };

    const trackEvent = (labeledKey, title) => {
        const eventMap = {
            'writeAPrompt': 2115,
            'autoRewrite': 2116,
            'summarize': 2117,
            'businessTone': 2118,
            'legalTone': 2119
        };
        const eventId = eventMap[labeledKey];
        if (eventId) {
            track(1, eventId, 'ckeditor_copilot', title);
        }
    };

    const setModalData = (label, title, aICommand, selectedData) => {
        setAICommand(aICommand);
        setLabel(label);
        setTitle(title);
        setSelectedData(selectedData);
    };

    const handleRegenerate = async () => {
        // Cancel any ongoing API call before starting a new one
        if (cancelTokenSource) {
            cancelTokenSource.cancel('Operation canceled by the user.');
        }
    
        // Create a new cancellation token source
        const source = axios.CancelToken.source();
        setCancelTokenSource(source);
    
        setIsKeepDisabled(true);
        const resp = await fetchData(`${aICommand} ${selectedData}`, source.token);
        if (resp) {
            let htmlString = resp.replace("```html\n", "");
            htmlString = htmlString.replace("```", "");
            htmlString = await convertTextToHTML(htmlString);
            if (aICommand === 'summarize') {
                htmlString = htmlString.replace(/\n/g, "</br>");
            }
            setResultData(htmlString);
        }
    };

    const handleWritePromptRegenerate = async () => {
        // Cancel any ongoing API call before starting a new one
        if (cancelTokenSource) {
            cancelTokenSource.cancel('Operation canceled by the user.');
        }
    
        // Create a new cancellation token source
        const source = axios.CancelToken.source();
        setCancelTokenSource(source);
    
        setIsKeepDisabled(true);
        const resp = await fetchData(`${aiContextValue} ${selectedData}`, source.token);
        if (resp) {
            let htmlString = resp.replace("```html\n", "");
            htmlString = htmlString.replace("```", "");
            htmlString = await convertTextToHTML(htmlString);
            // htmlString = htmlString.replace(/\n/g, "</br>");
    
            setResultData(htmlString);
        }
    };

    const handleWritePromptKeep = async () => {
        try {
            const instanceId = modalInstanceId;
            const event = new CustomEvent('keepData', { detail: { resultData, instanceId } });
            document.dispatchEvent(event);
            handleCloseWriteAPrompt();
        } catch (error) {
            console.error('Error dispatching event:', error);
        }
    };

    const handleKeep = async () => {
        try {
            const instanceId = modalInstanceId;
            const event = new CustomEvent('keepData', { detail: { resultData, instanceId } });
            document.dispatchEvent(event);
            handleCloseLabel();
        } catch (error) {
            console.error('Error dispatching event:', error);
        }
    };

    const handleGenerate = async () => {
        setIsKeepDisabled(true);
        const resp = await fetchData(`${aiContextValue} ${selectedData}`, cancelTokenSource.token);
        if (resp) {
            let htmlString = resp.replace("```html\n", "");
            htmlString = htmlString.replace("```", "");
            htmlString = await convertTextToHTML(htmlString);
            // htmlString = htmlString.replace(/\n/g, "</br>");
            setResultData(htmlString);
            setShowWriteAPromptButtons(true);
            track(1, 2160, 'ckeditor_copilot', aiContextValue);
        }
    };

    const handleCloseLabel = () => setShowLabelModal(false);

    useEffect(() => {
        const showLabelButton = document.getElementById('showLabelButton');
        if (showLabelButton) {
            showLabelButton.addEventListener('showAutoModal', handleShowLabel);
        }
        return () => {
            if (showLabelButton) {
                showLabelButton.removeEventListener('showAutoModal', handleShowLabel);
            }
        };
    }, []);

    useEffect(() => {
        const showWriteAPromptButton = document.getElementById('showWriteAPromptButton');
        if (showWriteAPromptButton) {
            showWriteAPromptButton.addEventListener('showWriteAPromptModal', handleShowWriteAPrompt);
        }
        return () => {
            if (showWriteAPromptButton) {
                showWriteAPromptButton.removeEventListener('showWriteAPromptModal', handleShowWriteAPrompt);
            }
        };
    }, []);

    return (
        <>
            <WriteAPromptComponent 
                show={showWriteAPromptModal} 
                handleClose={handleCloseWriteAPrompt} 
                showLoader={showLoader}
                handleAIPromptTextChange={handleAIPromptTextChange}
                aiContextValue={aiContextValue}
                handleGenerate={handleGenerate}
                resultData={resultData}
                selectedData={selectedData}
                showWriteAPromptButtons={showWriteAPromptButtons}
                handleWritePromptRegenerate={handleWritePromptRegenerate}
                handleWritePromptKeep={handleWritePromptKeep}
                isKeepDisabled={isKeepDisabled}
            />
            <button onClick={handleShowWriteAPrompt} className="hidden-button d-none" id="showWriteAPromptButton">Show Modal</button>

            <LabelComponent 
                show={showLabelModal}
                handleClose={handleCloseLabel}
                modelName={label}
                title={title}
                selectedData={selectedData}
                resultData={resultData}
                handleRegenerate={handleRegenerate}
                handleKeep={handleKeep}
                showLoader={showLoader}
                isKeepDisabled={isKeepDisabled}
            />
            <button onClick={handleShowLabel} className="hidden-button d-none" id="showLabelButton">Show Modal</button>
        </>
    );
};

export const renderModalContainer = () => {
    let modalContainer = document.getElementById('modal-container');
    if (!modalContainer) {
        modalContainer = document.createElement('div');
        modalContainer.id = 'modal-container';
        document.body.appendChild(modalContainer);
    }

    const root = createRoot(modalContainer);
    root.render(
        <ModalContainer />
    );
};